module.exports = __webpack_public_path__ + "static/media/wwd_mechanics.8dd14627.svg";